// Shell copy, verbatim from the live captures (docs/reference/live/shell-*.md) or Clockify's en.json.
export const s = {
  sectionAnalyze: "Analyze",
  sectionManage: "Manage",
  showMore: "Show more",
  showLess: "Show less",
  sidebarCollapse: "sidebar collapse",
  openNavigation: "Open navigation",
  switcher: "Switch workspace",
  switcherCreate: "Create workspace",
  workspaceOptions: "Workspace options",
  workspaceSettings: "Workspace settings",
  manageWorkspaces: "Manage workspaces",
  notifications: "Notifications",
  clearAll: "Clear all",
  noNotifications: "No new notifications",
  help: "Help",
  helpCenter: "Help",
  whatsNew: "What's new",
  profileMenu: "Profile",
  manageAccount: "Manage account",
  myProfile: "My profile",
  preferences: "Preferences",
  logOut: "Log out",
  back: "Back",
  notFoundTitle: "Oops! Page not found.",
  notFoundLine1: "Please check if you have just slightly misspelt the address",
  notFoundLine2: "Not sure why you're here? You can",
  notFoundLink: "go back to standard Time tracker.",
  notFoundFooter: "If you think something is wrong, contact your Clockify admin.",
  modulePending: (name: string) => `${name} module pending`,
  settingsPending: "This settings section is not built yet.",
  kioskPending: "Kiosk mode is not built yet.",
  sharedReportPending: "Shared reports are not built yet.",
  bootError: "It seems there's a problem connecting to our servers. We're investigating the issue.",
  retry: "Try again",
};
